module.exports = __webpack_public_path__ + "static/img/team-img-bg.00f60c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-img-bg.png
// module id = ZRVw
// module chunks = 0